import { 
  GET_WASTABLE_ITEMS,
  GET_WASTE_DATA,
  LOAD_MORE_WASTE_DATA
} from '../actions/types';

const wastable_data = {
  wastableItems: [],
  data: [],
  origData:[],
  dataCount:0,
  dataNext:null,
  dataPrevious:null,
  editModalOpen: false,
  previewModalOpen: false,
  item:[],
  currentProps:null,


};





// eslint-disable-next-line import/no-anonymous-default-export
export default (state = wastable_data, action) => {
  var dataArray;
  switch (action.type) {   
    case GET_WASTABLE_ITEMS:            
      return {  
        ...state,
        wastableItems:action.payload   
      };


    case GET_WASTE_DATA:         
      var  newdata = action.payload.dataArray
      var  lastVisible = action.payload.lastVisible
      return {  
        origData:newdata,
        data: newdata,
        dataCount:newdata.length,
        lastVisible:lastVisible,
        currentProps:action.payload.currentProps
      };

    case LOAD_MORE_WASTE_DATA:         
      var  newdata = action.payload.dataArray
      var  lastVisible = action.payload.lastVisible
      return {  
        ...state,
        origData:newdata.concat(state.origData),
        data: newdata.concat(state.data),
        dataCount:newdata.concat(state.origData).length,
        lastVisible:lastVisible,
     
      };
   
    default:
      return state;
  }
};
